/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { fixedT, translationKeys } from "../Internationalisierung/i18nDomainDrivenDesign";
import { Feld, FeldRegel, Typ, VergleichsRegel } from "./PromiseLadeTypen";

export default class LadeTypenUtil {
    public static findeTyp(typen: Typ[] | undefined, typBezeichnung: string): Typ {
        if (!typen) {
            throw new Error(fixedT(translationKeys.ladeTypenUtil.typenNichtGeladen));
        }

        const typ = typen.find((e) => e.bezeichnung === typBezeichnung);
        if (!typ) {
            throw new Error(
                fixedT(translationKeys.ladeTypenUtil.typNichtGeladen, { typBezeichnung })
            );
        }

        return typ;
    }

    public static findeFeld(typ: Typ, feldBezeichnung: string): Feld {
        const feld = typ.felder.find(
            (f) => f.bezeichnung.toLowerCase() === feldBezeichnung.toLowerCase()
        );
        if (!feld) {
            throw new Error(
                fixedT(translationKeys.ladeTypenUtil.feldNichtGeladen, {
                    typBezeichnung: typ.bezeichnung,
                    feldBezeichnung,
                })
            );
        }

        return feld;
    }

    public static hatRegeln(feld: Feld, regelBezeichnungen: Array<string>): boolean {
        return regelBezeichnungen.some((bezeichnung) => {
            const mitBezeichnung = (regel: FeldRegel | VergleichsRegel) => regel.bezeichnung === bezeichnung;
            return feld.feldRegeln.some(mitBezeichnung) || feld.vergleichsRegeln.some(mitBezeichnung);
        });
    }
}
